module.exports = __webpack_public_path__ + "static/img/partner-logo9.08a5d089.jpg";